import styled from 'styled-components';
export const ContactInformationContainer = styled.div `
  display: flex;
  flex-direction: column;
  ${props => props.theme.mixins.mobile('margin: 0 60px;')};
  @media (max-width: 700px) { margin: 0 15px; }
  @media (max-width: 450px) { margin: 0 10px; }
`;
export const Title = styled.h4 `
  margin-bottom: 15px;
`;
export const Street = styled.p `
  font-weight: 600;
  margin:0;
`;
export const HoursWrapper = styled.div `
  padding: 20px 0;
`;
export const Text = styled.p `
  text-transform: ${props => props.textTransform};
  margin: 0;
  padding: ${props => props.padding};
`;
export const SocialLink = styled.a `
  display: flex;
  padding-top: 40px;
  font-weight: bold;
  &:hover{
    transform: scale(1.05);
  }
`;
export const PhoneMailLink = styled.a `
  margin: 0;
  ${props => props.underline && 'text-decoration: underline;'}
  &:hover {
    color: ${props => props.theme.colors.hover};
  }
`;
